import { t } from '@/lib/i18n';
import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@ant-design/pro-components';
import { requireCanManageUsers } from '@/features/auth/session/guards';
import { SessionManager } from '@/features/user/session/manager';
import { useDocumentTitle } from '@/hooks/use-document-title';

export const Route = createFileRoute('/_authenticated/system/monitor/sessions')(
  {
    /** Monitoring remains administrator-only, matching the API's authorization boundary. */
    beforeLoad: async ({ context, location }) => {
      await requireCanManageUsers(context.queryClient, location.href);
    },
    component: SessionsPage,
  },
);

/** Dedicated entry for viewing and revoking a user's server-side sessions. */
function SessionsPage() {
  useDocumentTitle(t('会话管理'));
  return (
    <PageContainer
      header={{ title: t('会话管理') }}
      content={t('按用户查看有效登录会话，并撤销单条或全部会话')}
    >
      <SessionManager />
    </PageContainer>
  );
}
